import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../footer/Footer';

const TermsOfService = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <div className="min-h-screen flex flex-col bg-gray-100">
            {/* Header */}
            <header className="border-b p-4" style={{ backgroundColor: "#0a3891", color: "white" }}>
                <div className="container mx-auto flex flex-wrap justify-between items-center">
                    <div className="text-2xl md:text-3xl font-bold flex items-center gap-2">
                        <h1>Prodyt</h1>
                    </div>
                    {/* Hamburger Menu Button */}
                    <button
                        className="block md:hidden text-white focus:outline-none"
                        onClick={() => setMenuOpen(!menuOpen)}
                    >
                        <i className={`fas ${menuOpen ? 'fa-times' : 'fa-bars'} text-2xl`}></i>
                    </button>
                    {/* Navigation Menu */}
                    <nav
                        className={`${
                            menuOpen ? 'block' : 'hidden'
                        } absolute top-12 right-4 bg-blue-900 z-10 rounded-md md:static md:w-auto md:bg-transparent md:flex flex-col md:flex-row gap-4 md:gap-6`}
                    >
                        <Link to="/" className="block text-white px-4 py-2 hover:bg-blue-700 transition duration-300">
                            Home
                        </Link>
                        <Link to="/about" className="block text-white px-4 py-2 hover:bg-blue-700 transition duration-300">
                            About Us
                        </Link>
                        <Link to="/privacy-policy" className="block text-white px-4 py-2 hover:bg-blue-700 transition duration-300">
                            Privacy Policy
                        </Link>
                        <Link to="/help-center" className="block text-white px-4 py-2 hover:bg-blue-700 transition duration-300">
                            Help Center
                        </Link>
                        <Link to="/terms-of-service" className="block text-white px-4 py-2 hover:bg-blue-700 transition duration-300">
                            Terms of Service
                        </Link>
                        <Link to="/delete-account" className="block text-white px-4 py-2 hover:bg-blue-700 transition duration-300">
                            Delete Account
                        </Link>
                    </nav>
                </div>
            </header>

            {/* Main Content */}
            <main className="flex-1 flex items-center justify-center p-4">
                <div className="bg-white border border-gray-300 rounded-lg shadow-lg p-6 md:p-8 max-w-lg md:max-w-3xl w-full">
                    <h1 className="text-2xl md:text-4xl font-bold mb-4 md:mb-6 text-center" style={{ color: "#0a3891" }}>
                        Terms of Service
                    </h1>
                    <p className="text-sm md:text-lg text-gray-600 mb-6 md:mb-8">
                        Welcome to Prodyt! By using our platform, you agree to the following terms and conditions. Please read them carefully.
                    </p>

                    {/* Section 1 */}
                    <h2 className="text-xl md:text-2xl font-bold mb-4" style={{ color: "#0a3891" }}>
                        1. Overview
                    </h2>
                    <p className="text-sm md:text-lg text-gray-600 mb-6">
                        Prodyt is a next-generation platform designed to simplify product registration, warranty tracking, and complaint management. By using our services, you agree to comply with these terms.
                    </p>

                    {/* Section 2 */}
                    <h2 className="text-xl md:text-2xl font-bold mb-4" style={{ color: "#0a3891" }}>
                        2. User Responsibilities
                    </h2>
                    <ul className="list-disc pl-6 text-sm md:text-lg text-gray-600 mb-6 space-y-2">
                        <li>Provide accurate and up-to-date information during product registration.</li>
                        <li>Ensure that your account credentials are kept secure and confidential.</li>
                        <li>Use the platform only for lawful purposes and in compliance with applicable laws.</li>
                    </ul>

                    {/* Section 3 */}
                    <h2 className="text-xl md:text-2xl font-bold mb-4" style={{ color: "#0a3891" }}>
                        3. Privacy and Data Protection
                    </h2>
                    <p className="text-sm md:text-lg text-gray-600 mb-6">
                        At Prodyt, we are committed to protecting your personal information. Please refer to our <Link to="/privacy-policy" className="text-blue-600 hover:underline">Privacy Policy</Link> for details on how we collect, use, and protect your data.
                    </p>

                    {/* Section 4 */}
                    <h2 className="text-xl md:text-2xl font-bold mb-4" style={{ color: "#0a3891" }}>
                        4. Limitations of Liability
                    </h2>
                    <p className="text-sm md:text-lg text-gray-600 mb-6">
                        Prodyt is not responsible for any indirect, incidental, or consequential damages arising from the use of our platform. We strive to provide accurate and reliable services but cannot guarantee uninterrupted access or error-free functionality.
                    </p>

                    {/* Section 5 */}
                    <h2 className="text-xl md:text-2xl font-bold mb-4" style={{ color: "#0a3891" }}>
                        5. Support and Contact
                    </h2>
                    <p className="text-sm md:text-lg text-gray-600 mb-6">
                        If you have any questions or need assistance, please visit our <Link to="/help-center" className="text-blue-600 hover:underline">Help Center</Link> or contact our support team.
                    </p>

                    {/* Section 6 */}
                    <h2 className="text-xl md:text-2xl font-bold mb-4" style={{ color: "#0a3891" }}>
                        6. Changes to Terms
                    </h2>
                    <p className="text-sm md:text-lg text-gray-600">
                        We reserve the right to update these terms at any time. Changes will be communicated through our platform, and continued use of our services constitutes acceptance of the updated terms.
                    </p>
                </div>
            </main>

            {/* Footer */}
            <Footer />
        </div>
    );
};

export default TermsOfService;